import React from 'react';
import ReactFlow, { Background, Controls, MarkerType, Position } from 'reactflow';
import 'reactflow/dist/style.css';

// Shared node/edge builders + canvas wrapper for the infra/module maps so both
// maps look identical and stay easy to maintain.

export function mkNode(id, x, y, title, sub, color, width = 210) {
  return {
    id,
    position: { x, y },
    data: {
      label: (
        <div className="cs-flow-node-inner">
          <div className="cs-flow-node-title">{title}</div>
          {sub ? <div className="cs-flow-node-sub">{sub}</div> : null}
        </div>
      ),
    },
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: {
      width,
      background: 'var(--bg-elev)',
      color: 'var(--text)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderLeft: `4px solid ${color}`,
      borderRadius: 8,
      padding: '8px 10px',
      fontSize: 12,
      textAlign: 'left',
    },
  };
}

export function mkEdge(s, t, label, { animated = false, color = 'rgba(255,255,255,0.25)' } = {}) {
  return {
    id: `${s}-${t}`,
    source: s,
    target: t,
    label,
    type: 'smoothstep',
    animated,
    style: { stroke: color, strokeWidth: 1.5 },
    labelStyle: { fill: 'var(--muted)', fontSize: 10 },
    labelBgStyle: { fill: 'var(--bg)', fillOpacity: 0.85 },
    markerEnd: { type: MarkerType.ArrowClosed, color },
  };
}

export function FlowCanvas({ nodes, edges, legend, height = 480, onNodeClick, interactive = true, fitPadding = 0.12 }) {
  return (
    <div className="cs-flow-wrap">
      <div className="cs-flow" style={{ height }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          fitView
          fitViewOptions={{ padding: fitPadding }}
          nodesConnectable={false}
          edgesFocusable={false}
          nodesDraggable={interactive}
          onNodeClick={onNodeClick}
          zoomOnScroll={interactive}
          zoomOnPinch={interactive}
          zoomOnDoubleClick={interactive}
          panOnDrag={interactive}
          panOnScroll={false}
          preventScrolling={interactive}
          proOptions={{ hideAttribution: true }}
          minZoom={0.25}
          maxZoom={1.5}
        >
          <Background color="rgba(255,255,255,0.06)" gap={20} />
          {interactive ? <Controls showInteractive={false} /> : null}
        </ReactFlow>
      </div>
      {legend ? (
        <div className="cs-flow-legend">
          {legend.map(([label, color]) => (
            <span key={label}><i style={{ background: color }} />{label}</span>
          ))}
        </div>
      ) : null}
    </div>
  );
}
